import PlaylistAddRemoveGraphql from './PlaylistAddRemoveGraphql'

export default PlaylistAddRemoveGraphql
// eslint-disable-next-line import/export
export * from './PlaylistAddRemoveGraphql'
